module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_vm._v("Illustrations")]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#fig.1"
    }
  }, [_vm._v("Fig. 1"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("George Frederick Watts, "), _c('em', [_vm._v("Jonah")]), _vm._v(", 1894.")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#fig.2"
    }
  }, [_vm._v("Fig. 2"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Jonah sarcophagus, ca. 280–300 CE, Museo Pio Cristiano, Vatican City. Photo by Sailko.")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#fig.3"
    }
  }, [_vm._v("Fig. 3"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Elijah and the widow’s son who, in some rabbinic texts, is identified as Jonah, Dura Europos synagogue, Syria.")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#fig.4"
    }
  }, [_vm._v("Fig. 4"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Hebrew manuscript produced in A Coruña (Spain) during the period of the Spanish Inquisition, 1476.")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#fig.5"
    }
  }, [_vm._v("Fig. 5"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Israeli stamp featuring Jonah in the whale’s belly.")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#fig.6"
    }
  }, [_vm._v("Fig. 6"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Whale memorial, 2003, Acre (Akko), Israel. Photo by Avishai Teicher.")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Introduction1#fig.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 7"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Jonah being thrown into the sea, ca. fourth century CE. From the Catacomb of Saint Peter and Saint Marcellino, Rome, Italy.")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Introduction1#fig.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 8"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Sculpture of Jonah being spit up by the fish, now in the Cleveland Museum of Art, late Roman, Asia Minor, ca. late third century CE. John L. Severance Fund.")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Introduction1#fig.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 9"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Sarcophagus of a child with the story of Jonah, ca. 300 CE. "), _c('em', [_vm._v("Below")]), _vm._v(", Jonah ejected by the whale; "), _c('em', [_vm._v("above")]), _vm._v(", Jonah under the castor-oil plant.")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration1"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Introduction2#fig.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 10"), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("Psalm 68 from the illuminated Psalter of Eleanor of Aquitaine, now in the Koninklijke Bibliotheek, ca. 1185.")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration1"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Introduction2#fig.11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 11"), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("Lieven van Lathem, "), _c('em', [_vm._v("The Entombment")]), _vm._v(", ca. 1471.")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration1"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Introduction2#fig.12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 12"), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("Column of the Duomo of Verona, Italy, ca. 1187. Photo by Anna De Grandis.")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration1"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Introduction2#fig.13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 13"), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("Michelangelo, Jonah on the Sistine Chapel, 1511.")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration1"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Introduction2#fig.14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 14"), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("Paul Bril, "), _c('em', [_vm._v("Jonah and the Whale")]), _vm._v(", ca. 1590.")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration1"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Introduction2#fig.15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 15"), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("Albrecht Dürer, "), _c('em', [_vm._v("Saint Jerome in His Study")]), _vm._v(", 1514.")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration1"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Introduction2#fig.16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 16"), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("Folio from the "), _c('em', [_vm._v("Jami"), _c('span', {
    staticClass: "font1"
  }, [_vm._v("ʿ")]), _vm._v(" al-Tawārikh")]), _vm._v(" (Compendium of Chronicles), ca. 1400.")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration1"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Introduction2#fig.17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 17"), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("Jonah and the fish, "), _c('span', {
    staticClass: "font"
  }, [_vm._v("ʿ")]), _vm._v("Uzayr (Ezra) awakened after the destruction of Jerusalem, and Jeremiah in the wilderness. In "), _c('em', [_vm._v("Zubdat al-Tawārīkh")]), _vm._v(", now in the Chester Beatty Library, 1585–1590.")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration1"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Commentary#fig.18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 18"), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("Jonah thrown to the fish, Joseph in the well, and Jesus entombed, from the "), _c('em', [_vm._v("Pauper’s Bible")]), _vm._v(", ca. 1470.")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration1"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Commentary#fig.19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 19"), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("Pieter Lastman, "), _c('em', [_vm._v("Jonah and the Whale")]), _vm._v(", 1621.")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration1"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Commentary1#fig.20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 20"), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("Gustave Doré, "), _c('em', [_vm._v("Jonah Preaches to the Ninevites (Jon. 3:1–10)")]), _vm._v(", 1866.")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration1"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Commentary1#fig.21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 21"), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("Watson Heston, "), _c('em', [_vm._v("What Moved God to Repent")]), _vm._v(", first appeared in "), _c('em', [_vm._v("The Truth Seeker")]), _vm._v(", November 3, 1894.")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration1"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary2#fig.22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 22"), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("Floor mosaic from the Cathedral of Santa Maria Assunta, Aquileia, Italy, fourth century CE. Photo by Yukio Sanjo.")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration1"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary2#fig.23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 23"), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("Jan van de Velde, "), _c('em', [_vm._v("Jonah under the Wonder Plant,")]), _vm._v(" now in the Rijksmuseum, early seventeenth century.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0904efb0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Illustration.vue
// module id = 72
// module chunks = 0